import { CultureInfo } from '../culture-info.model';
import { CultureInfoMs } from './ms';

/**
 * @ignore
 */
export const CultureInfoMsMY: CultureInfo = {
  name: 'ms-MY',
  displayName: 'Malay (Malaysia)',
  iso3LanguageCode: 'msa',
  iso2LanguageCode: 'ms',
  ietfLanguageTag: 'ms-MY',
  parent: CultureInfoMs
};
